import * as CONSTRUCTOR from '../../generate';

export const bankSharedMediaResponse = CONSTRUCTOR.FRAGMENT({
  name: 'SharedMedia',
  fragmentName: 'BankSharedMediaResponseFields',
  fields: `{
    id
    parent_type
    parent_id
    file_name
    file_type
    file_content_type
    file_url
    uploader_name
    uploaded_at
    created_at
    updated_at
  }`,
});

export const bankSharedMediaListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListSharedMediasResponse',
  fragmentName: 'BankSharedMediaListResponseFields',
  fields: `{
    shared_medias {
      id
      parent_type
      parent_id
      file_name
      file_type
      file_url
      uploaded_at
      created_at
    }
    total_count
    limit
    offset
  }`,
});

export const streamBankSharedMediaFileResponse = CONSTRUCTOR.FRAGMENT({
  name: 'StreamSharedMediaFileResponse',
  fragmentName: 'StreamBankSharedMediaFileResponseFields',
  fields: `{
    file_content
    content_type
    content_disposition
    cache_control
    file_name
    url
  }`,
});
